<script setup lang="ts">
import { ref } from 'vue';

import { useTruncate } from '@thehotelsnetwork/usables';

const container = ref();
const { isTruncate } = useTruncate(container);

const showFullContent = ref(false);
const isMouseOver = ref(false);

const toogleFullContent = () => {
  showFullContent.value = !showFullContent.value;
};

</script>
<template>
  <div
    class="flex"
    @mouseenter="isMouseOver = true"
    @mouseleave="isMouseOver = false"
    @focusin="isMouseOver = true"
    @focusout="isMouseOver = false"
  >
    <div
      ref="container"
      :class="[
        'flex-1',
        !showFullContent && `truncate`,
      ]"
    >
      <slot
        v-bind="{
          isTruncate,
          showFullContent,
          toogleFullContent,
          isMouseOver,
        }"
      />
    </div>
    <slot
      v-if="isTruncate"
      name="showMore"
      v-bind="{ toogleFullContent }"
      class="flex-shrink-0"
    />
  </div>
</template>
